module.exports = __webpack_public_path__ + "images/product_jalapeno_4.a062a606.jpg";